// THIS FILE IS AUTO-GENERATED - DO NOT EDIT
import React from 'react';

const AtlantaIllustratedMap = React.lazy(() => import('./atlanta-illustrated/AtlantaIllustratedMap'));
const AtlantaPrototypeMap = React.lazy(() => import('./atlanta-prototype/AtlantaPrototypeMap'));
const AtlantaZonesMap = React.lazy(() => import('./atlanta-zones/AtlantaZonesMap'));
const CarolinaPrototypeMap = React.lazy(() => import('./carolina-prototype/CarolinaPrototypeMap'));
const CarolinaZonesMap = React.lazy(() => import('./carolina-zones/CarolinaZonesMap'));
const CelestialTerrainMap = React.lazy(() => import('./celectial-terrain/CelestialTerrainMap'));
const ChicagoRoadsMap = React.lazy(() => import('./chicago-roads/ChicagoRoadsMap'));
const ContiguousUsaMap = React.lazy(() => import('./usa-map/contiguous/ContiguousUsaMap'));
const ContinentalUsaMap = React.lazy(() => import('./usa-map/continental/ContinentalUsaMap'));
const EuropeMap = React.lazy(() => import('./europe-map/EuropeMap'));
const ExamplesMap = React.lazy(() => import('./examples/ExamplesMap'));
const GreekIslandsMap = React.lazy(() => import('./greek-islands/GreekIslandsMap'));
const IranNewsMap = React.lazy(() => import('./iran-news/IranNewsMap'));
const LouisvilleTigerMap = React.lazy(() => import('./louisville-tiger/LouisvilleTigerMap'));
const LouisvilleZonesMap = React.lazy(() => import('./louisville-zones/LouisvilleZonesMap'));
const MiddleEarthMap = React.lazy(() => import('./middle-earth/MiddleEarthMap'));
const OceanAntiquaMap = React.lazy(() => import('./ocean-antiqua/OceanAntiquaMap'));
const PerturbationMap = React.lazy(() => import('./perturbation/PerturbationMap'));
const RvLifeMap = React.lazy(() => import('./rv-life/RvLifeMap'));
const TestMap = React.lazy(() => import('./test-map/TestMap'));
const TestOptionsMap = React.lazy(() => import('./test-options/TestOptionsMap'));
const TestSvgResoureMap = React.lazy(() => import('./test-svg-resource/TestSvgResoureMap'));
const WorldMap = React.lazy(() => import('./world-map/WorldMap'));
const WorldOptionsMap = React.lazy(() => import('./world-options/WorldOptionsMap'));

export interface MapInfo {
  id: string;
  name: string;
  component: React.ComponentType;
}

const mapRegistry: MapInfo[] = [
  {
    id: 'atlanta-illustrated--atlanta-illustrated',
    name: 'Atlanta Illustrated',
    component: AtlantaIllustratedMap
  },
  {
    id: 'atlanta-prototype--atlanta-prototype',
    name: 'Atlanta Prototype',
    component: AtlantaPrototypeMap
  },
  {
    id: 'atlanta-zones--atlanta-zones',
    name: 'Atlanta Zones',
    component: AtlantaZonesMap
  },
  {
    id: 'carolina-prototype--carolina-prototype',
    name: 'Carolina Prototype',
    component: CarolinaPrototypeMap
  },
  {
    id: 'carolina-zones--carolina-zones',
    name: 'Carolina Zones',
    component: CarolinaZonesMap
  },
  {
    id: 'celectial-terrain--celestial-terrain',
    name: 'Celestial Terrain',
    component: CelestialTerrainMap
  },
  {
    id: 'chicago-roads--chicago-roads',
    name: 'Chicago Roads',
    component: ChicagoRoadsMap
  },
  {
    id: 'usa-map-contiguous--contiguous-usa',
    name: 'Contiguous Usa',
    component: ContiguousUsaMap
  },
  {
    id: 'usa-map-continental--continental-usa',
    name: 'Continental Usa',
    component: ContinentalUsaMap
  },
  {
    id: 'europe-map--europe',
    name: 'Europe',
    component: EuropeMap
  },
  {
    id: 'examples--examples',
    name: 'Examples',
    component: ExamplesMap
  },
  {
    id: 'greek-islands--greek-islands',
    name: 'Greek Islands',
    component: GreekIslandsMap
  },
  {
    id: 'iran-news--iran-news',
    name: 'Iran News',
    component: IranNewsMap
  },
  {
    id: 'louisville-tiger--louisville-tiger',
    name: 'Louisville Tiger',
    component: LouisvilleTigerMap
  },
  {
    id: 'louisville-zones--louisville-zones',
    name: 'Louisville Zones',
    component: LouisvilleZonesMap
  },
  {
    id: 'middle-earth--middle-earth',
    name: 'Middle Earth',
    component: MiddleEarthMap
  },
  {
    id: 'ocean-antiqua--ocean-antiqua',
    name: 'Ocean Antiqua',
    component: OceanAntiquaMap
  },
  {
    id: 'perturbation--perturbation',
    name: 'Perturbation',
    component: PerturbationMap
  },
  {
    id: 'rv-life--rv-life',
    name: 'Rv Life',
    component: RvLifeMap
  },
  {
    id: 'test-map--test',
    name: 'Test',
    component: TestMap
  },
  {
    id: 'test-options--test-options',
    name: 'Test Options',
    component: TestOptionsMap
  },
  {
    id: 'test-svg-resource--test-svg-resoure',
    name: 'Test Svg Resoure',
    component: TestSvgResoureMap
  },
  {
    id: 'world-map--world',
    name: 'World',
    component: WorldMap
  },
  {
    id: 'world-options--world-options',
    name: 'World Options',
    component: WorldOptionsMap
  }
];

export default mapRegistry;
